import {CaseStyle} from "kryo";
import {RecordIoType, RecordType} from "kryo/record";

import {$BestLevelRun, BestLevelRun} from "./best-level-run.mjs";
import {$BestScoreRun, BestScoreRun} from "./best-score-run.mjs";

export interface BestRunsForMode {
  maxScore: BestScoreRun;
  minScore: BestScoreRun;
  maxLevel: BestLevelRun;
}

export const $BestRunsForMode: RecordIoType<BestRunsForMode> = new RecordType<BestRunsForMode>({
  properties: {
    maxScore: {type: $BestScoreRun},
    minScore: {type: $BestScoreRun},
    maxLevel: {type: $BestLevelRun},
  },
  changeCase: CaseStyle.SnakeCase,
});
